<script setup>

import {ref, watch} from "vue";
import axios from "axios";

const emit = defineEmits(['update'])

const props = defineProps({
    subject: {
        type: String,
        required: true
    },
    body: {
        type: String,
        required: true
    },
})

const editingEmail = ref(false)

const _subject = ref(props.subject)
const _body = ref(props.body)

const updateEmailContent = async () => {
    await axios.post(route('assistant.updateBaseEmail'), {
        subject: _subject.value,
        content: _body.value
    });
    emit('update')
}

watch(editingEmail, (newValue) => {
    if (! newValue) {
        updateEmailContent();
    }
}, {deep: true});

</script>

<template>
<div>
    <div class="flex justify-between mb-2">
        <h2>{{ _mft('leadHunter:baseEmail') }}</h2>
        <button-base
            size="sm"
            :style-type="editingEmail ? 'success' : 'secondary'"
            @click="editingEmail = !editingEmail"
        >
            {{ editingEmail ? 'Done' : 'Edit' }}
        </button-base>
    </div>

    <div
        class="p-4 -mx-4 bg-gray-50 md:-mx-6 md:p-6"
    >
        <div class="flex items-center justify-between space-x-4">
            <span class="font-bold">{{ _mft('leadHunter:email.subject') }}</span>
            <container-with-tooltip
                v-if="! editingEmail"
                alignment="center"
                tooltip-class="mb-1 bg-white text-xs px-1 py-0.5 rounded shadow-md text-xss"
            >
                <template #tooltip>
                    {{ _mft('shared:copy') }}
                </template>

                <copyable-text
                    :show-url="false"
                    :copyable-text="_subject.replace(/<[^>]*>/g, '\n').replace(/\n{2,}/g, '\n')"
                />
            </container-with-tooltip>
        </div>
        <input-text
            v-if="editingEmail"
            v-model:content="_subject"
        />
        <div v-else>
            {{ _subject }}
        </div>

        <hr class="mt-4 mb-4">

        <div class="flex items-center justify-between space-x-4">
            <span class="font-bold">{{ _mft('leadHunter:email.content') }}</span>
            <container-with-tooltip
                v-if="! editingEmail"
                alignment="center"
                tooltip-class="mb-1 bg-white text-xs px-1 py-0.5 rounded shadow-md text-xss"
            >
                <template #tooltip>
                    {{ _mft('shared:copy') }}
                </template>

                <copyable-text
                    :show-url="false"
                    :copyable-text="_body.replace(/<[^>]*>/g, '\n\n').replace(/\n{2,}/g, '\n\n').replace(/&nbsp;/g, ' ')"
                />
            </container-with-tooltip>
        </div>

        <input-editor
            v-if="editingEmail"
            v-model:content="_body"
        />
        <div
            v-else
            v-html="_body"
        >
        </div>
    </div>
</div>
</template>

<style scoped>

</style>
